import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

interface Props {
  NameBusiness: string;
  login: string;
  tempPassword: string;
  YourJWTToken: string;
  YourJWTTokenForWebhook: string;
}

const CredsForm: React.FC<Props> = ({
  NameBusiness,
  login,
  tempPassword,
  YourJWTToken,
  YourJWTTokenForWebhook
}) => {
  // Текст для отображения и копирования
  const formattedText = `
  ----------------------------------------------------------------------------
  ${NameBusiness}

  Личный кабинет: https://merchant.trustech.cash
  Логин: ${login}
  Пароль (временный): ${tempPassword}
  После ввода временного пароля система потребует установить постоянный пароль.

  API Doc: https://api.trustech.cash/swagger/index.html
  API хост: https://api.trustech.cash

  YOUR_JWT_TOKEN: ${YourJWTToken}
  YOUR_JWT_TOKEN_FOR_WEBHOOK: ${YourJWTTokenForWebhook}
  ----------------------------------------------------------------------------
  `;

  // Стейт для отображения сообщения об успешном копировании
  const [copied, setCopied] = useState(false);

  // Функция для копирования текста в буфер обмена
  const copyToClipboard = () => {
    navigator.clipboard.writeText(formattedText).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Убираем сообщение через 2 секунды
    });
  };

  return (
    <div>
      <textarea
        readOnly
        value={formattedText}
        rows={17}
        style={{ width: '100%', fontFamily: 'monospace' }}
      />
      <Button onClick={copyToClipboard}>
        {copied ? 'Скопировано!' : 'Копировать'}
      </Button>
    </div>
  );
};

export default CredsForm;
